module.exports = __webpack_public_path__ + "img/axess.fb9dbf5c.png";